<template>
  <main id="main" style="margin-top: -20px; padding-bottom: 300px;">
    <div class="container">
      <div class="form">
        <div class="row">
          <div class="col-md-12 col-lg-8">
            <div class="section-header">
              <h2>Payments</h2>
            </div>
          </div>
        </div>
        <div v-if="checkAccess" class="row">
          <div class="col">
            <listView
              :items="payments"
              :showNew="false"
              @onEdit="Edit"
              @onDelete="Delete"
            />
          </div>
        </div>
        <div v-else class="row">
          <div class="col">
            <alert
              :text="'You don\'t have permission to view this page'"
              :type="'ERROR'"
            />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
/* eslint-disable */
import { mapState, mapActions } from 'vuex'

import Log from '../../assets/Log'
import alert from '../shared/alert'
import listView from '../shared/listView.vue'

export default {
  name: 'PaymentList',
  components: {
    listView,
    alert,
  },
  data() {
    return {
      userId: Log.getUser().Id,
    }
  },
  methods: {
    ...mapActions('payment', ['getPayments']),
  },
  mounted() {
    this.getPayments()
  },
  computed: {
    ...mapState('payment', ['payments']),
    UserChanged() {
      this.getProperties(Object.assign(this.user.id))
      return this.user
    },
    checkAccess() {
      if (Log.getUser().role === 'Super Admin') {
        return true
      } else {
        return false
      }
    },
  },
}
</script>
